import filter from 'lodash/filter';
import {
  fetchManagerAssignments,
  patchManagerAssignment,
  postManagerAssignment,
  removeManagerAssignment,
} from './api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const loadManagerAssignments = createAsyncThunk(
  'managerAssignments/fetchManagerAssignments',
  async _ => await fetchManagerAssignments(),
);
export const createManagerAssignment = createAsyncThunk(
  'managerAssignments/postManagerAssignment',
  async ({ talentId, values }) => await postManagerAssignment(talentId, values),
);
export const updateManagerAssignment = createAsyncThunk(
  'managerAssignments/patchManagerAssignment',
  async ({ talentId, assignmentId, values }) =>
    await patchManagerAssignment(talentId, assignmentId, values),
);
export const deleteManagerAssignment = createAsyncThunk(
  'managerAssignments/removeManagerAssignment',
  async assignmentId => await removeManagerAssignment(assignmentId),
);

const managersSlice = createSlice({
  name: 'managerAssignments',
  initialState: {
    managerAssignments: [],
    loading: true,
  },
  extraReducers: builder => {
    builder
      .addCase(loadManagerAssignments.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(loadManagerAssignments.fulfilled, (state, action) => {
        state.managerAssignments = action.payload.data;
        state.loading = false;
      })
      .addCase(createManagerAssignment.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(createManagerAssignment.fulfilled, (state, action) => {
        state.loading = false;
        state.managerAssignments = [
          ...state.managerAssignments,
          action.payload.data,
        ];
      })
      .addCase(updateManagerAssignment.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(updateManagerAssignment.fulfilled, (state, action) => {
        state.loading = false;
        state.managerAssignments = state.managerAssignments.map(assignment =>
          assignment.id !== action.payload.data.id
            ? assignment
            : action.payload.data,
        );
      })
      .addCase(deleteManagerAssignment.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(deleteManagerAssignment.fulfilled, (state, action) => {
        state.loading = false;
        state.managerAssignments = filter(
          state.managerAssignments,
          assignment => assignment.id !== action.meta.arg,
        );
      });
  },
  selectors: {
    getManagerAssignments: state => state.managerAssignments,
    getManagersLoading: state => state.loading,
  },
});

export const reducer = managersSlice.reducer;
export const {
  getManagerAssignments,
  getManagersLoading,
} = managersSlice.selectors;
